// Powers the PDP main purchase form (sections/main-product.liquid): resolves
// the VELO variant option cards (radio groups, one per option position) to
// the matching real variant, disables option values unavailable given the
// rest of the current selection (Dawn-like cross-option availability check),
// swaps price/compare-at-price/add-to-cart state/variant image, and wires
// the custom black "Buy with Pay" CTA (data-apple-pay-cta — not Shopify's
// native payment_button) to the shared window.Velo.checkoutSelectedVariant
// action (assets/checkout-selected-variant.js), reused identically in
// assets/pack-offer-picker.js and assets/collection-product-card.js.
//
// The Apple Pay CTA is wired unconditionally (as long as the button and the
// hidden variant-id input exist) - it must NOT depend on the option-card
// resolution logic below, because products with only a default variant
// (product.has_only_default_variant) render zero [data-option-position]
// cards. Previously this whole script (including the CTA) returned early in
// that case, leaving the button with no click handler at all on every
// single-variant PDP.
(function () {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantIdInput = form.querySelector('[data-variant-id]');
  var applePayBtn = form.querySelector('[data-apple-pay-cta]');
  var errorContainer = form.querySelector('[data-cart-error]');

  var jsonEl = document.querySelector('[data-product-json]');
  var data = null;
  if (jsonEl) {
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      data = null;
    }
  }

  var variants = (data && data.variants) || [];
  var optionInputs = form.querySelectorAll('[data-option-position]');
  var priceEl = document.querySelector('[data-price]');
  var compareAtPriceEl = document.querySelector('[data-compare-at-price]');
  var addToCartBtn = form.querySelector('[data-add-to-cart]');

  if (optionInputs.length && variantIdInput && variants.length) {
    (function initVariantCards() {
      function currentSelection() {
        var selection = {};
        optionInputs.forEach(function (input) {
          if (input.checked) selection[input.dataset.optionPosition] = input.value;
        });
        return selection;
      }

      function findVariant(selection) {
        var positions = Object.keys(selection);
        return variants.find(function (variant) {
          return positions.every(function (position) {
            return variant.options[position - 1] === selection[position];
          });
        });
      }

      function isValueAvailable(position, value, selection) {
        var hypothetical = Object.assign({}, selection);
        hypothetical[position] = value;
        var positions = Object.keys(hypothetical);
        return variants.some(function (variant) {
          var matches = positions.every(function (p) {
            return variant.options[p - 1] === hypothetical[p];
          });
          if (!matches) return false;
          // A "Pack of N" value is never added to the cart as itself, so its
          // own inventory is irrelevant - what decides availability is the
          // Single variant it resolves to (the only SKU actually sold).
          return window.Velo.resolvePackSubmission(variant, variants).variant.available;
        });
      }

      function updateCardStates(selection) {
        optionInputs.forEach(function (input) {
          var available = isValueAvailable(input.dataset.optionPosition, input.value, selection);
          input.disabled = !available;
          var card = input.closest('.velo-variant-card');
          if (card) {
            card.classList.toggle('velo-variant-card--unavailable', !available);
            card.classList.toggle('velo-variant-card--selected', input.checked);
          }
        });
      }

      // Delegates to assets/product-gallery.js's own controller
      // (root.veloGallery) instead of touching gallery DOM directly - keeps a
      // single source of truth for gallery state/timers. Prefers the real
      // Shopify media id; falls back to matching the rendered image src for
      // variants without featured_media metadata.
      function updateVariantImage(variant) {
        if (!variant) return;
        var galleryRoot = document.querySelector('[data-product-gallery]');
        if (!galleryRoot || !galleryRoot.veloGallery) return;

        if (variant.media_id) {
          galleryRoot.veloGallery.selectByMediaId(variant.media_id);
        } else if (variant.image) {
          galleryRoot.veloGallery.selectBySrc(variant.image);
        }
      }

      // `selectedVariant` is what the customer's option cards resolve to;
      // `cartVariant` is what is actually POSTed to /cart/add.js. They differ
      // only for "Pack of N", which is a storefront pricing option, never a
      // real cart line - it submits the SINGLE variant with a quantity
      // multiplier (window.Velo.resolvePackSubmission), so Shopify orders,
      // inventory, and Aramex only ever see the Single SKU.
      function updateForVariant(selectedVariant) {
        if (!selectedVariant) return;
        var submission = window.Velo.resolvePackSubmission(selectedVariant, variants);
        var cartVariant = submission.variant;

        variantIdInput.value = cartVariant.id;

        if (priceEl) {
          priceEl.textContent = window.Velo.formatMoney(cartVariant.price);
        }
        if (compareAtPriceEl) {
          var hasCompareAt = cartVariant.compare_at_price && cartVariant.compare_at_price > cartVariant.price;
          compareAtPriceEl.classList.toggle('hidden', !hasCompareAt);
          if (hasCompareAt) {
            compareAtPriceEl.textContent = window.Velo.formatMoney(cartVariant.compare_at_price);
          }
        }

        if (addToCartBtn) {
          addToCartBtn.disabled = !cartVariant.available;
          addToCartBtn.classList.toggle('opacity-50', !cartVariant.available);
          addToCartBtn.classList.toggle('cursor-not-allowed', !cartVariant.available);
          addToCartBtn.dataset.variantId = cartVariant.id;
          addToCartBtn.dataset.price = cartVariant.price;
          addToCartBtn.dataset.compareAtPrice = cartVariant.compare_at_price || 0;
          addToCartBtn.dataset.packMultiplier = submission.multiplier;
          addToCartBtn.dataset.isSingleVariant = cartVariant.options.some(function (value) {
            return window.VeloPricing.isSingleValue(value);
          });
        }
        window.Velo.refreshAddToCartText(form);
        if (applePayBtn) {
          applePayBtn.disabled = !cartVariant.available;
        }

        // Image follows the customer's actual selection (a Pack of N value can
        // have its own lifestyle shot), not the substituted Single variant.
        updateVariantImage(selectedVariant);
      }

      function refresh() {
        var selection = currentSelection();
        var variant = findVariant(selection);
        updateCardStates(selection);
        updateForVariant(variant);
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', refresh);
      });

      refresh();
    })();
  }

  // "Build your pack" (assets/pack-builder.js) resolves to 2 REAL variants
  // at once (multi-item, since the native Shopify Bundle mechanism was
  // removed - see snippets/pack-builder.liquid) and owns its own Apple Pay
  // click handler instead - skip the single-variant wiring below entirely
  // so the button never gets two competing click handlers.
  var hasPackBuilder = !!form.querySelector('[data-cart-items-json]');

  if (applePayBtn && variantIdInput && !hasPackBuilder) {
    applePayBtn.addEventListener('click', function () {
      if (applePayBtn.disabled) return;
      // Physical quantity (displayed x pack multiplier) and the Single
      // variant id - identical payload to the native form submit.
      var quantity = window.Velo.getPhysicalQuantity(form);
      window.Velo.checkoutSelectedVariant({
        variantId: variantIdInput.value,
        quantity: quantity,
        button: applePayBtn,
        errorContainer: errorContainer
      });
    });
  }
})();
